// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const ShaderControlsContract = contract({
  name: "ShaderControls",
  description: "Render a `ControlSpec[]` schema into a DS-native control panel — the single renderer behind shader params, the post-processing stack, and any effect layer (they all describe themselves as ControlSpec[]). Reach for it whenever you have a list of named, typed parameters to expose as a tweaker panel and want it to read identically to the Studio inspector. DS-consistent by construction: it composes the primitives at tool-panel density (Label size=\"xs\", Slider size=\"sm\", ghost Input, ToggleGroup, Select, Switch) — never bespoke markup.",
  import: "@gradeui/ui",
  aliases: ["shader controls","control panel","params panel","tweaker","parameter panel","controlspec renderer","effect controls","schema controls"],
  composesWith: ["Label","Slider","Input","ToggleGroup","Select","Switch","Card"],
  styleDefaults: {"ShaderControls":"flex flex-col","Row":"text-muted-foreground"},
  props: {
  "controls": {
      schema: z.enum(["ControlSpec[]"]),
      design: "knob",
      description: "the schema to render. Each spec describes one control (slider / toggle / select / switch / input) and its range, step, label, and display.",
  },
  "value": {
      schema: z.enum(["DemoState"]),
      design: "knob",
      description: "controlled state object keyed by control name; the parent owns it.",
  },
  "onChange": {
      schema: z.enum(["(key, value) => void"]),
      design: "event",
      description: "fired on every control change.",
  },
  "labelPosition": {
      schema: z.enum(["inline", "above"]).optional(),
      design: "knob",
      description: "dense inline (label left, control + value right) or stacked label-above; default inline.",
  },
  "numberFormat": {
      schema: z.enum(["raw", "percent"]).optional(),
      design: "knob",
      description: "\"percent\" normalises eligible sliders (no unit, fractional step, non-negative) to 0–100%; a control's own `display: \"percent\"` always wins. Default raw.",
  },
  },
});
